export default {

  props: [
    'propIcons'
  ],

  data () {
    return {
      computed: {
        icons: null
      }
    }
  },

  computed: {
    icons: {
      get: function () {
        if (this.computed.icons) {
          return this.computed.icons
        }

        return this.propIcons
      }
    }
  }
}
